import { Box, Separator, ShimmerText, VStack } from '@betterment/samba-react';

const ShimmerRow = ({ labelWidth, subLabelWidth }: { labelWidth: string; subLabelWidth?: string }) => (
  <VStack css={{ gap: 'space.100' }}>
    <ShimmerText textStyle="text100" style={{ width: labelWidth, height: '12px' }} />
    {subLabelWidth && <ShimmerText textStyle="text50" style={{ width: subLabelWidth, height: '12px' }} />}
  </VStack>
);

export const LoadingPayrollCard = () => (
  <>
    <Box css={{ mb: 'space.300' }}>
      <ShimmerRow labelWidth="169.25px" />
    </Box>
    <Separator />

    <VStack css={{ pt: 'space.300', gap: 'space.200' }}>
      <ShimmerRow labelWidth="200px" subLabelWidth="79px" />
      <ShimmerRow labelWidth="200px" subLabelWidth="79px" />
    </VStack>
  </>
);
